import { RequestFactory } from '../../api/RequestFactory';
import { patchApiUrl } from '../../api/config';

const pmRequest = new RequestFactory(`${patchApiUrl}/seias/rest/seocc/patch/1.0`);

export { pmRequest };



// WEBPACK FOOTER //
// ./src/actions/pm/requestFactory.ts